import { render, staticRenderFns } from "./TPApplicationsCountPerDurationCard.vue?vue&type=template&id=37037ad2&"
import script from "./TPApplicationsCountPerDurationCard.vue?vue&type=script&lang=js&"
export * from "./TPApplicationsCountPerDurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports